"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownArrow = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
require("./DropdownArrow.scss");
const DropdownArrow = (props) => {
    const { className = '', direction = 'bottom', onClick } = props;
    const classNames = (0, classnames_1.default)((0, classFunctions_1.getClassNames)('dropdown-arrow', [
        direction === 'bottom' ? 'direction-bottom' : 'direction-top',
    ]), className);
    return (react_1.default.createElement("div", { className: 'dropdown-arrow__wrapper', onClick: onClick },
        react_1.default.createElement("div", { className: classNames })));
};
exports.DropdownArrow = DropdownArrow;
//# sourceMappingURL=DropdownArrow.js.map